import safeAwait from '../../../../lib/safeAwait'
import errorHelper, { httpHandler } from '../../../../lib/errorHelper'

const fetchStruDataAttrClusterOptions = async (actions, params) => {
  const [error, payload] = await safeAwait(
    actions.fetchStruDataAttrClusterOptions(params).then(httpHandler)
  )
  const errorMessage = errorHelper.parseErrorMessage(error)
  if (errorMessage) {
    return [{ message: errorMessage, params }]
  }

  return [undefined, payload]
}

export default fetchStruDataAttrClusterOptions
